var useDisabledCheck = function (checked, keysForCustomFunction) {
    var isDisabled = checked === null || checked === void 0 ? void 0 : checked.some(function (x) { var _a; return x.isin_id === ((_a = keysForCustomFunction === null || keysForCustomFunction === void 0 ? void 0 : keysForCustomFunction[7]) !== null && _a !== void 0 ? _a : ""); });
    var disabledClass = isDisabled ? "disabled" : "";
    return { isDisabled: isDisabled, disabledClass: disabledClass };
};
export default useDisabledCheck;
